import { useTasks } from 'app/domains/tasks/components/TasksProvider';
import { PreviewTaskDialog } from './PreviewTaskDialog';
export function PreviewTask() {
    const { activeTask, isEditing } = useTasks();
    if (!activeTask || isEditing) {
        return null;
    }
    return <PreviewTaskDialog />;
}
